export default "__VITE_ASSET__aLzmm0LK__"